import type { IContactCompanyDetails } from './ContactCompanyDetails.interface';
import Address from '../address/Address';
import ContactPreferredContactMethod from './ContactPreferredContactMethod';

export default class ContactCompanyDetails implements IContactCompanyDetails {
  phoneCode: string;
  phone: string;
  faxCode: string;
  fax: string;
  email: string;
  website: string;
  preferredContactMethod: ContactPreferredContactMethod;
  address: Address;
  registeredAddress: Address;
  mailingAddress: Address;

  static build = (data: IContactCompanyDetails) => new ContactCompanyDetails(data);
  static blank = () => new ContactCompanyDetails();

  /**
   * Constructor
   * @param {IContactCompanyDetails} data
   */
  constructor(data?: IContactCompanyDetails) {
    this.phoneCode = data?.phoneCode || '';
    this.phone = data?.phone || '';
    this.faxCode = data?.faxCode || '';
    this.fax = data?.fax || '';
    this.email = data?.email || '';
    this.website = data?.website || '';
    this.preferredContactMethod = new ContactPreferredContactMethod(
      data?.preferredContactMethod
    );
    this.address = new Address(data?.address);
    this.mailingAddress = new Address(data?.mailingAddress);
    this.registeredAddress = new Address(data?.registeredAddress);
  }
}
